usi_installed = 0;
USI_installCode = function () {
  if (usi_installed == 0) {
    usi_installed = 1;
    var USI_headID = document.getElementsByTagName('head')[0];
    var USI_installID = document.createElement('script');
    USI_installID.type = 'text/javascript';
    USI_installID.src = 'https://www.upsellit.com/active/petivity.jsp';
    USI_headID.appendChild(USI_installID);
  }
};
if (
  typeof document.readyState != 'undefined' &&
  document.readyState === 'complete'
) {
  USI_installCode();
} else if (window.addEventListener) {
  window.addEventListener('load', USI_installCode, true);
} else if (window.attachEvent) {
  window.attachEvent('onload', USI_installCode);
} else {
  USI_installCode();
}
setTimeout('USI_installCode()', 10000);
